import { useCallback } from 'react'
import { text } from './Constants'
import './PatientResultItem.scss'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const PatientResultItem = ({ result, isLast, selectItem }) => {
  const onSelectItem = useCallback(() => {
    selectItem(result)
  }, [result, selectItem])
  return (
    <div role='presentation' className='new-visit-patient-result-item-container' onClick={onSelectItem}>
      <div className='new-visit-patient-result-item-text-container'>
        <label htmlFor='null' className='new-visit-patient-result-item-text new-visit-patient-result-item-text-bold'>
          {text.NAME}
        </label>
        <label htmlFor='null' className='new-visit-patient-result-item-text'>
          {`${result.FirstName} ${result.LastName}`}
        </label>
      </div>

      <div className='new-visit-patient-result-item-text-container'>
        <label
          htmlFor='null'
          className='new-visit-patient-result-item-text new-visit-patient-result-item-text-bold new-visit-patient-result-item-text-mrn'>
          {text.MRN}
        </label>
        <label htmlFor='null' className='new-visit-patient-result-item-text'>
          {result.MedicalRecordNumber}
        </label>
      </div>
      <div className='new-visit-patient-result-item-text-container'>
        <label htmlFor='null' className='new-visit-patient-result-item-text new-visit-patient-result-item-text-bold'>
          {text.EMAIL}
        </label>
        <label htmlFor='null' className='new-visit-patient-result-item-text'>
          {result.Email}
        </label>
      </div>

      {!isLast && <div className='new-visit-patient-result-item-separate-line' />}
    </div>
  )
}
